import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "components/Common/Button";
import InputPassword from "components/Common/InputPassword";
import { saveClientPlatform, deletePlatform, updatePlatform } from "actions";
import "./style.scss";

class SettingsPlatformsMessengerModal extends React.Component {
  updatePlatform(payload) {
    this.props.updatePlatform(this.props.platformType, payload);
  }

  render() {
    const isButtonDisabled = (
      (this.props.platform.get("isPublished") && !this.props.platform.get("isDirty")) ||
      !this.props.platform.get("isValid")
    );

    return (
      <div className="SettingsPlatformsMessengerModal Modal__modal">
        <h5 className="Modal__title">
          Configure Facebook Messenger
        </h5>
        <div className="Modal__content">
          <section className="Modal__section">
            <section className="Modal__section__sub-section">
              <label className="Modal__section__sub-section__title g-input__label" htmlFor="SettingsPlatformsMessengerModal__access-token">
                Page Access Token
              </label>
              <p className="Modal__section__sub-section__description">
                You can get one of these from developers.facebook.com
              </p>
              <InputPassword
                value={this.props.platform.get("record").accessToken}
                placeholder="Access Token"
                inputId="SettingsPlatformsMessengerModal__access-token"
                customClassName="SettingsPlatformsMessengerModal__access-token"
                onPasswordChange={e => this.updatePlatform({ accessToken: e.target.value })}
              />
            </section>
          </section>
        </div>
        <div
          className="Modal__bottom SettingsPlatformsMessengerModal__bottom"
        >
          <Button
            onClick={() => this.props.saveClientPlatform(this.props.platform)}
            text="Save"
            title="Save"
            icon="Cloud"
            disabled={isButtonDisabled}
            isLoading={this.props.platform.get("isLoading")}
            customClassName="SettingsPlatformsMessengerModal__bottom__save"
          />
          {!!this.props.platform.get("isPublished") && (
            <Button
              onClick={() => this.props.deletePlatform(this.props.platform)}
              text="Delete"
              title="Delete"
              icon="Delete"
              light
              customClassName="SettingsPlatformsMessengerModal__bottom__delete"
            />
          )}
        </div>
      </div>
    );
  }
}

function mapState(state, ownProps) {
  const { platforms } = state;

  return {
    platforms,
    platform: platforms.get(ownProps.platformType)
  };
}

function mapDispatch(dispatch) {
  return {
    saveClientPlatform: bindActionCreators(saveClientPlatform, dispatch),
    deletePlatform: bindActionCreators(deletePlatform, dispatch),
    updatePlatform: bindActionCreators(updatePlatform, dispatch)
  };
}

const Connector = connect(mapState, mapDispatch)(SettingsPlatformsMessengerModal);

export default Connector;
